//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Swiper from '@/utils/swiper.min.js'
export default {
    name: "ShopVewDetail",
    props: ["imgList", "image"],
    data() {
        return {
            swiperList: [],
            imgPoster: "",

        };
    },

    mounted() {
        this.swiperList = this.imgList;
        console.log(this.swiperList);
        // if (this.swiperList && this.swiperList.length > 0) {
        //     this.imgPoster = this.swiperList[0];
        // }
        // var arr = this.swiperList.filter(item => item.flag != 20); //不等于20 代表不是视频
        // if (arr && arr.length > 0) {
        //     this.imgPoster = arr[0].imgUrl;
        // }

        //imgPoster
        this.$nextTick(() => {
            this.swiperFun();
        })
    },

    methods: {
        swiperc() {
            var that = this;
            var swiper = new Swiper(".mySwiper", {
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                on: {
                    click: function () {
                        if (this.clickedIndex != undefined) {
                            that.swiperBigShow = true;
                        }
                    }
                }
            })

        },
        swiperFun() {
            var that = this;
            var galleryThumbs = new Swiper(".gallery-thumbs", {
                spaceBetween: 10,
                slidesPerView: "auto",
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true //修改swiper的父元素时，自动初始化swiper
            });
            var galleryTop = new Swiper(".gallery-top", {
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                thumbs: {
                    swiper: galleryThumbs
                },
                on: {
                    click: function () {
                        if (this.clickedIndex != undefined) {
                            //alert(this.clickedSlide.firstChild.currentSrc)
                            that.swiperBigShow = true;
                            that.srcImg = this.clickedSlide.firstChild.currentSrc;
                        }

                    }
                }
            });

        }
    },
};
